import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Input from '../../../components/UI/Input/Input';
import Card from '@material-ui/core/Card';
import classes from './../../../index.css';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Aux from '../../../hoc/Aux';
import axios from '../../../axios-ns';
import * as messages from '../../../messages';

class TransactionOptions extends Component {
    state = {
        error: null,
        loading: true,
        controls: null
    };

    componentDidMount() {
        axios.get('protected/transaction/' + this.props.match.params.transactionCode + '/options', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(res => {
                let controls = {};

                res.data.forEach(d => {
                    controls[d.transactionOptionCode] = {
                        elementType: 'select',
                        value: d.val,
                        elementConfig: {
                            label: messages[d.name],
                            options: JSON.parse(d.availableValues).map(av => { return { value: av, displayValue: messages[av] }; })
                        },
                    }
                })

                this.setState({ ...this.state, controls: controls, loading: false });
            })
            .catch(err => {
                console.log("An error occured");
            });
    }

    checkValidity(value, rules) {
        let isValid = true;

        if (!rules) {
            return true;
        }

        if (rules.required) {
            isValid = value.trim() !== '' && isValid;
        }

        if (rules.minLength) {
            isValid = value.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid;
        }

        return isValid;
    }

    inputChangedHandler = (event, controlName) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                valid: this.checkValidity(event.target.value, this.state.controls[controlName.validation]),
                touched: true
            }
        };
        this.setState({ controls: updatedControls });
    }

    submitHandler = (event) => {
        event.preventDefault();

        let transactionOptions = Object.keys(this.state.controls).map(k => {
            console.log(JSON.stringify(this.state.controls[k]));
            return {
                transactionOptionCode: k,
                val: this.state.controls[k].value
            }
        });

        this.saveOptions(transactionOptions);
    }

    saveOptions(transactionOptions) {
        axios.put('protected/transaction-options', transactionOptions, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(res => {
                this.props.history.replace('/protected/training/' + this.props.match.params.transactionCode);
            }).catch(err => {
                console.log(err);
            })
    }

    render() {
        const formElementsArray = [];
        for (let key in this.state.controls) {
            formElementsArray.push({
                id: key,
                config: this.state.controls[key]
            });
        }

        let form = formElementsArray.map(
            formElement => (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    changed={(event) => this.inputChangedHandler(event, formElement.id)}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    touched={formElement.config.touched}
                    value={formElement.config.value} />
            )
        );

        let errorMessage = null;

        if (this.state.error) {
            errorMessage = (
                <p style={{ color: '#f50057' }}>{this.state.error}</p>
            )
        }

        let view = null;
        if (this.state.isAuthenticated) {
            view = <Redirect to='/protected/dashboard' />
        } else {
            view = (<Card className={classes.Form}>
                <CardHeader title={messages.TRAINING_OPTIONS} className={classes.Head} />
                {errorMessage}
                <form onSubmit={this.submitHandler}>
                    {form}
                    <div style={{marginBotton: '20px'}}>
                        <Button color="primary" variant="outlined" type="submit" style={{margin: '10px'}}>
                            {messages.SAVE}
                        </Button>
                        <Button variant="outlined" type="button" component={Link} to={'/protected/training/' + this.props.match.params.transactionCode} style={{color: 'orange', borderColor: 'orange'}}>
                            {messages.CANCEL}
                        </Button>
                    </div>
                </form>
            </Card>
            );
        }

        if (this.state.loading) {
            view = <Spinner />
        }

        return (
            <Aux>
                {view}
            </Aux>
        )
    }
}

export default TransactionOptions; 